import dayjs from 'dayjs';

//  日期格式化
export const formatDate = function (date, fmt) {
  const o = {
    'y+': date.getFullYear(), // 年份
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      String(date.getFullYear()).substr(4 - RegExp.$1.length),
    );
  }
  Object.keys(o).forEach((item) => {
    if (new RegExp(`(${item})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        Number(RegExp.$1.length) === 1 ? o[item] : `00${o[item]}`.substr(String(o[item]).length),
      );
    }
  });
  return fmt;
};

export const formatTimestamp = function (timestamp, fmt) {
  const date = new Date(timestamp);
  return formatDate(date, fmt);
};

export function priceFormat(value) {
  if (+value < 0) {
    return '无收益';
  }
  return value;
}

export const formatAmount = function (value) {
  return (Number(value) / 100 || 0).toFixed(2);
};
export const formatYearMonth = function (dateStr) {
  const date = dayjs(`${dateStr}`);
  return date.format('YYYY年MM月');
};

export const getMonth = function (dateStr) {
  return dayjs(`${dateStr}`).month() + 1;
};

export const getMonthDay = function (dateStr) {
  const date = dayjs(`${dateStr}`);
  return date.format('MM月DD日');
};

export const transformNumberToStr = (val) => (typeof val === 'number' ? String(val) : val);

export const getLabel = function (val, list) {
  const info = list.filter((item) => item.value === val);
  return info[0] && info[0].label;
};

export const formatRatio = function (ratio) {
  ratio = Number(ratio) || 0;
  return `${ratio / 100}%`;
};

export function formatTableColumns(columns) {
  columns.forEach((col) => {
    const formatter = col.formatter;
    col.formatter = (row, col2, value) => {
      const v = formatter ? formatter(row, col2, value) : value;
      if (v === undefined || v === null || v === '') {
        return '-';
      } else {
        return v;
      }
    };
  });
  return columns;
}
